import { useEffect, useState } from 'react'
import Latex from 'react-latex-next'

import { Button, Alert } from '@mui/material';

type Props = {
    eid: string
    estado: boolean | undefined
    handleRespuestaUsuario: Function
    alternativas: Array<Alternativa>
}

type Alternativa = {
    letra: string
    alternativa: string
    estado: null | boolean
}

type State = {
    ok: null | Boolean
    title: string
    msg: string
}

const FormularioSM = ({ eid, estado, handleRespuestaUsuario, alternativas }: Props) => {

    const [respuestaUsuario, setRespuestaUsuario] = useState<Alternativa>({ letra: '', alternativa: '', estado: null });
    const [state, setState] = useState<State>({
        ok: null,
        title: '',
        msg: ''
    });

    const [alert, setAlert] = useState(false);

    useEffect(() => {
        if (alert) {
            const timer = setTimeout(() => { setAlert(false); }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alert]);

    const handleRespuesta = () => {

        if (respuestaUsuario.estado === true) {
            setAlert(true);
            setState({
                ok: respuestaUsuario.estado,
                title: '¡Felicitaciones!',
                msg: 'Has seleccionado la alternativa correcta'
            });
            handleRespuestaUsuario({
                ok: respuestaUsuario.estado,
                title: '¡Felicitaciones!',
                msg: 'Has seleccionado la alternativa correcta'
            })
        }

        if (respuestaUsuario.estado === false) {
            setAlert(true);
            setState({
                ok: respuestaUsuario.estado,
                title: '¡Sigue intentando!',
                msg: 'Has seleccionado una alternativa equivocada'
            });
            handleRespuestaUsuario({
                ok: respuestaUsuario.estado,
                title: '¡Sigue intentando!',
                msg: 'Has seleccionado una alternativa equivocada'
            })
        }
    }

    return (
        <div>
            {
                alternativas.map(item => {
                    const { letra, alternativa } = item;

                    return alternativa && (
                        <div
                            key={letra}
                            className='card-body d-flex align-items-center'
                            style={{ padding: '1rem', paddingLeft: '0.5rem', minHeight: '60px', borderTop: '#D3D3D3 solid 1px' }}
                        >
                            <input
                                className='mx-2 align-text-bottom'
                                type="radio"
                                name={eid}
                                onChange={() => setRespuestaUsuario(item)}
                                disabled={estado !== undefined}
                            />
                            <Latex>
                                {item.alternativa}
                            </Latex>
                        </div>
                    )
                })
            }

            <div className="card-footer">
                <div className="row my-0">
                    <div className="col-12 p-0 py-2">
                        <Button
                            className='float-start'
                            sx={{ margin: 0 }}
                            color="primary"
                            variant="outlined"
                            onClick={() => handleRespuesta()}
                            aria-label="close"
                            disabled={alert || respuestaUsuario.letra === '' || estado !== undefined}
                        >
                            Revisar
                        </Button>
                    </div>
                </div>
                {
                    alert &&
                    <Alert
                        severity={state.ok === null ? 'info' : (state.ok ? 'success' : 'error')}
                        sx={{ position: 'relative', mt: 1 }}
                    >
                        {state.title} {state.msg}
                    </Alert>
                }
            </div>
        </div>
    )
}

export default FormularioSM